import React, { Component } from 'react';
import { gettemplatemasterData, GetPOAndLineItemListForDispatch, GetPOAndLineItemListForDispatchonPONumber, GetPOAndLineItemListForDispatchICListing, GetPOAndLineItemListForDispatchForDCListing, GetPOAndLineItemListForDispatchBillingScheduleDetails, GetPOAndLineItemListForDispatchInspectionDetails, GetPOAndLineItemListForDispatchCount, postDispatchClearenceDetails, VendorDetails,getCustomerMaster } from '../store/actions/dispatchOrderDetailsActions';
import { connect } from 'react-redux'
import swal from 'sweetalert';
import toast from 'react-hot-toast';
import { Button, Table, Form, InputGroup, FormControl, Dropdown, ThemeProvider } from 'react-bootstrap';
import Modal from '../Components/CustomModal';
import ModalHeader from '../Components/ModalHeader';
import ModalBody from '../Components/ModalBody';
import ModalFooter from '../Components/ModalFooter';
import AuthHandler from '../Classes/AuthHandler';
import { uploadFileGeneric, generateDispatchClearence } from '../store/actions/fileActions'
import Select from 'react-select';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { GetFilterList } from '../store/actions/masterActions'
// import { CSVLink } from "react-csv";
import { getProjectAllocationByUserId } from '../store/actions/poDetailsActions';
import Loading from '../Components/Loader';
import parse from 'html-react-parser';
import ModalTemplate from 'react-bootstrap/Modal';
import Pagination from 'react-bootstrap/Pagination';
import dateFormater from '../Classes/FormatDate'

class DispatchClearanceTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedOption: null,
            dispatch_data: [],
            selected: [],
            iclistData: [],
            PONumber: "",
            vendorName: "NA",
            VendorCountry: "",
            VendorState: "",
            Rows: "",
            tableCustomer:[],
            tabledata: [],
            dropDownArray: [],
            dropDownArrayPoNumber: [],
            tabledata1: [],
            PDCvalue: "",
            checkedArray: [],
            select: false,
            modal: false,
            templateModal: false,
            reviseForm: {
                file: [],
                comment: ""
            },
            billingScheduleDetails: [],
            selectedPoId: 0,
            selectedPOSAPId: "",
            isShowFilter: false,
            filterByPOSAPId: [],
            ponumber: [],
            filterByVendorName: [],
            vendor: [],
            sendTo: [
                { label: "Customer", value: "Customer" },
                { label: "Vendor", value: "Vendor" }
            ],
            sendToValue: "Vendor",
            Consignee: {
                "Name": "",
                "Address": "",
                "GSTIN": ""
            },
            VendorAddress: "",
            VendorAddress2: "",
            VendorGSTIn: "",
            VendorPin: "",
            csvData: [],
            sortByWBS: [],
            WBSCode: [],
            sortByPlantCode: [],
            PlantCode: [],
            VendorName: "",
            VendorLabel: "",
            CustomerLable:"",
            VendorDetails: "",
            SendToVendorAddress: "",
            SendToVendorGSTIn: "",
            vendorPOData: [],
            SendToPurchaseOrderId: 0,
            SendToPOSAPID: '',
            DCTemplate: '',
            DCTemplateLabel: '',
            DCLISTcountforPONO: 0,
            templateDataPreview: '',
            vendorPOLineItems: [],
            templateDataArray: [],
            templateDataArray1: [],
            ToVendorPOLineItemNo: 0,
            SelectedProjectCode: '',
            SalesPerson: '',
            BillingScheduleDetails: [],
            templateDataPreview1: '',
            POCreationDate: '',
            loading: false,
            activepage: 1,
            activepage1: 1,
            offsetVal: 0,
            offsetVal1: 0,
            RowCount: 10,
            RowCountPO: 100,
            totalrowcount: 0,
            totalrowcount2: 0,
            totalrowcountPO: 0,
            pageNumbers:[],
            pageNumbers1:[],
            pageNumbersPo:[],
        };
        this.modal = this.modal.bind(this)
    }

    dataSync = async () => {
        if (new URLSearchParams(this.props.location.search).get("searchTerm") && new URLSearchParams(this.props.location.search).get("searchFor") == 'PO Number') {
            let POSAPId = new URLSearchParams(this.props.location.search).get("searchTerm")
            this.state.filterByPOSAPId.push(POSAPId)
        }
        this.getFilterList()
        let searchdata = {
            userId: 0,
            filterByPOSAPId: this.state.filterByPOSAPId,
            filterByVendorName: this.state.filterByVendorName,
            sortByPlantCode: this.state.sortByPlantCode,
            sortByWBS: this.state.sortByWBS,
            offsetVal: this.state.offsetVal,
            offsetVal1: this.state.offsetVal1,
            RowCount: this.state.RowCount,
        }
        console.log("searchdata", searchdata)
        await this.props.GetPOAndLineItemListForDispatch(searchdata)
        await this.props.GetPOAndLineItemListForDispatchICListing(searchdata)
        await this.props.GetPOAndLineItemListForDispatchForDCListing(searchdata)
        await this.props.GetPOAndLineItemListForDispatchBillingScheduleDetails(searchdata)
        await this.props.GetPOAndLineItemListForDispatchInspectionDetails(searchdata)
        await this.props.GetPOAndLineItemListForDispatchCount(searchdata)

        let dropDownArray = []
        let tabledata1 = []
        let BillingScheduleDetails = []
        let checkedArray = []
        let csvData = []
        let reviseForm = {
            file: [],
            comment: ""
        }
        let iclistData = []
        let select = false
        let tabledata = await this.props.dispatchOrderDetailsReducer.getPOAndLineItemDetails.recordset.filter(item => ((item.icqty - item.IssuedQuantity) - item.RequestedQuantity) != 0)
        let totalrowcount = await this.props.dispatchOrderDetailsReducer.getPOAndLineItemDetails.recordsets[1][0].count
        let totalrowcount2 = await this.props.dispatchOrderDetailsReducer.getPOAndLineItemDetailsICListing.recordsets[1][0].count
        BillingScheduleDetails = await this.props.dispatchOrderDetailsReducer.getPOAndLineItemDetailsBillingScheduleDetails.recordset

        console.log(this.state.offsetVal1, "iclistinggg")

        if (this.props.dispatchOrderDetailsReducer.getPOAndLineItemDetailsInspectionDetails.recordset && this.props.dispatchOrderDetailsReducer.getPOAndLineItemDetailsInspectionDetails.recordset.length > 0) {
            iclistData = this.props.dispatchOrderDetailsReducer.getPOAndLineItemDetailsICListing.recordset.filter(item => ((item.icqty - item.IssuedQuantity) - item.RequestedQuantity) == 0)
        }
        let poNumberArray = await this.props.dispatchOrderDetailsReducer.getPOAndLineItemListForDispatchCount.recordsets[1]
        await poNumberArray.map((data) => {
            if (dropDownArray.filter(item => item.value == data.PurchaseOrderId).length == 0) {
                let ProjectCode = data.WBSCode == null || data.WBSCode == '' ? "Other" : (data.WBSCode).substring(0, 2) == "ET" ? (data.WBSCode).slice(0, 11) : (data.WBSCode).slice(0, 6)
                dropDownArray.push({ label: data.POSAPId, value: data.PurchaseOrderId, "ProjectCode": ProjectCode })
            }
        })
        // await tabledata.map((data) => {
        //     // if (dropDownArray.filter(item => item.value == data.PurchaseOrderId).length == 0) {
        //     //     let ProjectCode = data.WBSCode == null || data.WBSCode == '' ? "Other" : (data.WBSCode).substring(0, 2) == "ET" ? (data.WBSCode).slice(0, 11) : (data.WBSCode).slice(0, 6)
        //     //     dropDownArray.push({ label: data.POSAPId, value: data.PurchaseOrderId, "ProjectCode": ProjectCode })
        //     // }
        //     // csvData.push({
        //     //     "Project Number": data.WBSCode ? (data.WBSCode).substring(0, 2) == "ET" ? (data.WBSCode).slice(0, 11) : (data.WBSCode).slice(0, 6) : "Other",
        //     //     "PO Line item Description": data.POLineItemDescription,
        //     //     "IC Number": `IC-${data.POSAPId}-${data.POLineItemSAPCode}`,
        //     //     "Vendor Name": data.VendorName,
        //     //     "PO Number": data.POSAPId,
        //     //     "PO Line item no": data.POLineItemSAPCode,
        //     //     "IC qty": data.icqty + " " + data.OrderUnit,
        //     //     "Qty already Issued DC": (data.IssuedQuantity == null ? 0 : data.IssuedQuantity) + " " + data.OrderUnit,
        //     //     "Balance Qty available for DC": (data.IssuedQuantity == null ? (data.icqty - 0).toFixed(2) : (data.icqty - data.IssuedQuantity).toFixed(2)) + " " + data.OrderUnit,
        //     //     "Present DC": data.RequestedQuantity ? data.RequestedQuantity : 0,
        //     //     "Remaining": (data.IssuedQuantity == null ? ((data.icqty - 0) - data.RequestedQuantity).toFixed(2) : ((data.icqty - data.IssuedQuantity) - data.RequestedQuantity).toFixed(2)) + " " + data.OrderUnit,
        //     //     "Customer Billing schedule No": data.BillingScheduleNo ? data.BillingScheduleNo : "",
        //     //     "Customer Billing Schedule Description": data.BillScheduleDescription ? data.BillScheduleDescription : "",

        //     // })
            // })
        if (this.state.selectedPoId != 0) {
            tabledata1 = [...tabledata]
            tabledata1 = tabledata1.filter((dataitem) => dataitem.PurchaseOrderId == this.state.selectedPoId)
        }

        let pageNumbers = []

        for (let i = 1; i <= Math.ceil(totalrowcount / this.state.RowCount); i++) {
            pageNumbers.push(i);
        }

        await this.setState({
            tabledata, dropDownArray, checkedArray, tabledata1, reviseForm, select, iclistData, csvData, BillingScheduleDetails, totalrowcount: totalrowcount, totalrowcount2: totalrowcount2, pageNumbers: pageNumbers
        })
        document.getElementById("FileDispatch").value = "";
    }

    //------------API CALL----------------------
    componentDidMount = async () => {
        let roles = AuthHandler.getRoles()
        let userId = AuthHandler.getUserID()

        if (roles[12]) {
            let sortByWBS = []
            let WBSCode = []
            await this.props.getProjectAllocationByUserId({ UserId: userId })
            let ProjectCodes = await this.props.poDetails.getProjectAllocationByUserId
            if (ProjectCodes.length > 0) {
                ProjectCodes.map((elem) => {
                    sortByWBS.push(elem.ProjectCode)
                    WBSCode.push({ label: elem.ProjectCode, value: elem.ProjectCode })
                })
            }
            await this.setState({ sortByWBS, WBSCode })
        }
        await this.dataSync()
        await this.getFilterList()
        await this.props.getCustomerMaster()
        let tableCustomer=[]
        tableCustomer = await this.props.dispatchOrderDetailsReducer.getCustomerMaster
        if(tableCustomer.length>0){
            this.setState({tableCustomer})
        }
    }

    // shouldComponentUpdate= async (nextState) => {
    //     if (this.state.offsetVal === nextState.offsetVal) {
    //       return false;
    //     }
    //     await this.dataSync()
    //     await this.getFilterList()
    //   }

    // componentDidUpdate= async (prevState) => {
    //     if (this.state.offsetVal !== prevState.offsetVal) {
    //         await this.dataSync()
    //    await this.getFilterList()
    //       }
    //   }

    getFilterList = async () => {
        await this.props.gettemplatemasterData()
        await this.props.GetFilterList()
        // console.log(this.props.filterList, 'filterList')

        let templateDataArray = []
        let dropDownArrayVendor = []
        let dropDownArrayPoNumber = []
        // await this.props.filterList[3].map(async (item) => {
        //     await dropDownArrayVendor.push({ label: item.VendorName, value: item.VendorName })
        // })
        await this.props.dispatchOrderDetailsReducer.getdispatchtemplatemasterdata.recordset.map(async (item) => {
            await templateDataArray.push({ label: item.TemplateName, value: item.dispatchTemplateId, "ProjectCode": item.ProjectNo, templateData: item.templateData })
        })
        let finalwbsno = []
        let finalplantcode = []
        await this.props.filterList[1].map(async (item) => {
            await finalplantcode.push({ label: item.PlantCode, value: item.PlantCode })
        })
        await this.props.filterList[2].map(async (item) => {
            await finalwbsno.push({ label: item.WBSCode, value: item.WBSCode })
        })
        await this.props.filterList[3].map(async (item) => {
            await dropDownArrayVendor.push({ label: item.VendorName, value: item.VendorName })
        })
        await this.props.filterList[4].map(async (item) => {
            await dropDownArrayPoNumber.push({ label: item.POSAPId, value: item.POSAPId })
        })
        await this.props.dispatchOrderDetailsReducer.getdispatchtemplatemasterdata.recordset.map(async (item) => {
            await templateDataArray.push({ label: item.TemplateName, value: item.dispatchTemplateId, "ProjectCode": item.ProjectNo, templateData: item.templateData })
        })
        let ponumber = []
        let vendor = []
        let WBSCode = []
        let PlantCode = []
        await this.state.sortByPlantCode.map(async (item) => {
            await PlantCode.push({ label: item, value: item })
        })
        await this.state.sortByWBS.map(async (item) => {
            await WBSCode.push({ label: item, value: item })
        })
        await this.state.filterByPOSAPId.map(async (item) => {
            await ponumber.push({ label: item, value: item })
        })
        await this.state.filterByVendorName.map(async (item) => {
            await vendor.push({ label: item, value: item })
        })
        await this.setState({ templateDataArray, dropDownArrayVendor, dropDownArrayPoNumber, ponumber, vendor, finalwbsno, finalplantcode, WBSCode, PlantCode })
    }

    handleChange = async () => {
        let select = !this.state.select;
        let t1 = [...this.state.tabledata1]
        var checkedArray = []
        await t1.map((item) => {
            if (select == true && item.IssuedQuantity != item.icqty) {
                checkedArray.push(item.PurchaseOrderLineId)
                item.RequestedQuantity = (item.IssuedQuantity == null ? ((item.icqty - 0) - item.RequestedQuantity).toFixed(2) : ((item.icqty - item.IssuedQuantity) - item.RequestedQuantity).toFixed(2))
            }
            else if (select == false) {
                item.RequestedQuantity = (item.RequestedQuantity == null ? item.RequestedQuantity : 0)
            }

        })
        await this.setState({ select: select, checkedArray, tabledata1: t1 });
    }
    //Check Input Value Condition
    handlePDCInput = async (e, index, indicator) => {
        let input = e.target.value
        let balanceQuant = this.state.tabledata1[index].IssuedQuantity == null ? this.state.tabledata1[index].icqty - 0 : this.state.tabledata1[index].icqty - this.state.tabledata1[index].IssuedQuantity
        if (input > balanceQuant) {
            swal("Please enter valid quantity", { icon: "error" })
            let tabledata1 = [...this.state.tabledata1]
            tabledata1[index].RequestedQuantity = ""
            await this.setState({ tabledata1 })
            return false
        } else if (input <= 0) {
            swal("Please enter valid quantity", { icon: "error" })
            let tabledata1 = [...this.state.tabledata1]
            tabledata1[index].RequestedQuantity = ""
            await this.setState({ tabledata1 })
            return false
        } else {
            let tabledata1 = [...this.state.tabledata1]
            tabledata1[index].RequestedQuantity = input
            tabledata1[index].remaining = balanceQuant - input
            await this.setState({ tabledata1 })
        }
    }
    handleSelectPOs = async (e) => {
        this.setState({ loading: true })
        let selectedPoId = e.value
        let selectedPOSAPId = e.label
        let SelectedProjectCode = e.ProjectCode
        console.log(e, "JKDJJAJLDJAJD")
        let dropDownArrayVendor = []
        let vendorPOData = []
        let vendorPOLineItems = []
        let VendorLabel = ""
        let SendToVendorAddress = ""
        let SendToVendorGSTIn = ''
        let DCTemplateLabel = ''
        console.log("jnbdsnds",this.state.tableCustomer)
        let  DCListDetail = []
        let DCLISTcountforPONO = 0;
        // let templateDataArray = [...this.state.templateDataArray]
        // let tabledata1 = [...this.state.tabledata]
        let templateDataArray1 = this.state.templateDataArray.filter((item) => (item.ProjectCode == SelectedProjectCode) || (SelectedProjectCode.substring(0, 2) == "ET" && (item.ProjectCode == 'Service orders Khurda' || item.ProjectCode == 'Service orders Gurgaon' || item.ProjectCode == 'Service orders Concast')) || (SelectedProjectCode.substring(0, 1) == "C" && item.ProjectCode == 'Other (for C Series)'))
        await this.props.gettemplatemasterData({ ProjectCode: SelectedProjectCode })
        dropDownArrayVendor = await this.props.dispatchOrderDetailsReducer.getdispatchtemplatemasterdata.recordsets[2]
        let searchdata = {
            userId: 0,
            filterByPOSAPId: this.state.filterByPOSAPId,
            filterByVendorName: this.state.filterByVendorName,
            sortByPlantCode: this.state.sortByPlantCode,
            sortByWBS: this.state.sortByWBS,
            PoNumber: selectedPoId,
            offsetVal: 0,
            offsetVal1: this.state.offsetVal1,
            RowCount: this.state.RowCountPO,
        }
        await this.props.GetPOAndLineItemListForDispatchonPONumber(searchdata)
        DCListDetail = await this.props.dispatchOrderDetailsReducer.getPOAndLineItemDetails.recordsets[1].filter((data) => data.POSAPId == selectedPOSAPId)
        let tabledata1 = await this.props.dispatchOrderDetailsReducer.getPOAndLineItemListForDispatchonPONumber.recordset.filter(item => ((item.icqty - item.IssuedQuantity) - item.RequestedQuantity) != 0)
        let totalrowcountPO = await this.props.dispatchOrderDetailsReducer.getPOAndLineItemListForDispatchonPONumber.recordsets[1][0].count
        DCLISTcountforPONO = DCListDetail.length;
        let vendorName = tabledata1[0].VendorName
        console.log("hgdsa",vendorName)
        let VendorState = tabledata1[0].VendorState
        let VendorCountry = tabledata1[0].VendorCountry
        let VendorAddress = tabledata1[0].VendorAddress
        let VendorAddress2 = tabledata1[0].VendorAddress2
        let VendorGSTIn = tabledata1[0].VendorGstin
        let VendorPin = tabledata1[0].VendorCity
        let POCreationDate = tabledata1[0].POCreationDate
        let SalesPerson = tabledata1[0].SalesPerson
        console.log("tabledata1", totalrowcountPO)
        await this.setState({ selectedPoId, tabledata1, totalrowcountPO: totalrowcountPO, vendorName, VendorState, VendorCountry, selectedPOSAPId, VendorAddress, VendorAddress2, VendorGSTIn, VendorPin, dropDownArrayVendor, templateDataArray1, VendorLabel, SendToVendorAddress, SendToVendorGSTIn, DCTemplateLabel, vendorPOData, vendorPOLineItems, SelectedProjectCode, POCreationDate, DCLISTcountforPONO, SalesPerson, loading: false })
    }
    handleConsigneeName = async(e) => {
        this.setState(prevState => ({
            Consignee: {
              ...prevState.Consignee,
              Name: e.label
            }
          }))
        
    //     let tabledata1 = [...this.state.tabledata1]
    //     tabledata1[index].VendorPOLineItemNo = input
    //     await this.setState({ tabledata1 })
    }
    billhandleChange = async (e, index) => {
        let input = e.target.value
        let tabledata1 = [...this.state.tabledata1]
        tabledata1[index].BillingScheduleNo = input
        await this.setState({ tabledata1 })
    }

    billDeschanldeChange = async (e, index) => {
        let input = e.target.value
        let tabledata1 = [...this.state.tabledata1]
        tabledata1[index].BillScheduleDescription = input
        await this.setState({ tabledata1 })
        // console.log(e.target.value)
    }
    handleCustomerPo = async (e, index) => {
        let input = e.target.value
        let tabledata1 = [...this.state.tabledata1]
        tabledata1[index].CustomerPo = input
        await this.setState({ tabledata1 })
    }
    // handleVendorPOLineItemNo = async (e, index) => {
    //     let input = e.target.value
    //     let tabledata1 = [...this.state.tabledata1]
    //     tabledata1[index].VendorPOLineItemNo = input
    //     await this.setState({ tabledata1 })
    // }
    handleToVendorPOLineItemNo = async (e, index) => {
        let VendorPOLineItemNo = e.label
        let tabledata1 = [...this.state.tabledata1]
        tabledata1[index].VendorPOLineItemNo = VendorPOLineItemNo
        // console.log(VendorPOLineItemNo, "VendorPOLineItemNo")
        await this.setState({ tabledata1, VendorPOLineItemNo })
        // await this.dataSync()
    }
    handleCustomerBillingScheduleQuantity = async (e, index) => {
        let input = e.target.value
        let tabledata1 = [...this.state.tabledata1]
        tabledata1[index].CustomerBillingScheduleQuantity = input
        await this.setState({ tabledata1 })
    }
    handleUOM = async (e, index) => {
        let input = e.target.value
        let tabledata1 = [...this.state.tabledata1]
        tabledata1[index].UOM = input
        await this.setState({ tabledata1 })
    }
    handleRemarks = async (e, index) => {
        let input = e.target.value
        let tabledata1 = [...this.state.tabledata1]
        tabledata1[index].Remarks = input
        await this.setState({ tabledata1 })
    }
    handleSingleCheckBoxChange = (index) => {
        var checkedArray = [...this.state.checkedArray]
        let t1 = [...this.state.tabledata1]
        if (!checkedArray.includes(index)) {
            checkedArray.push(index)
            t1.find(item => item.PurchaseOrderLineId == index).RequestedQuantity = (t1.find(item => item.PurchaseOrderLineId == index).IssuedQuantity == null ? ((t1.find(item => item.PurchaseOrderLineId == index).icqty - 0) - t1.find(item => item.PurchaseOrderLineId == index).RequestedQuantity).toFixed(2) : ((t1.find(item => item.PurchaseOrderLineId == index).icqty - t1.find(item => item.PurchaseOrderLineId == index).IssuedQuantity) - t1.find(item => item.PurchaseOrderLineId == index).RequestedQuantity).toFixed(2))
        } else {
            checkedArray = checkedArray.filter(item => item !== index)
            t1.find(item => item.PurchaseOrderLineId == index).RequestedQuantity = (t1.find(item => item.PurchaseOrderLineId == index).RequestedQuantity == null ? t1.find(item => item.PurchaseOrderLineId == index).RequestedQuantity : 0)
        }
        // console.log(checkedArray, "abcdef")
        this.setState({ checkedArray, tabledata1: t1 });
    };
    modal = async () => {
        await this.setState({ modal: !this.state.modal });
        if (this.state.modal == true) {
            this.setState(
                { opacity: "" }
            )
        }
        else {
            this.setState(
                { opacity: "0.2" }
            )
        }
    }
    previewTemplate = async () => {
        var html = this.state.templateDataPreview;
        if (html !== '') {
            console.log(this.state, "JSKSJSKSJS")
            var CustomerTable = ''
            var VendorTable = ''
            var BillingScheduleTable = ''
            if (this.state.checkedArray.length > 0) {
                if (this.state.sendToValue === 'Vendor') {
                    VendorTable += '<table width="100%" style="border-spacing:0;margin-top:20px;padding-left:20px;padding-right:20px;">'
                        + '<tbody>'
                        + '<tr>'
                        + '<th style="margin-bottom: 0px;color: #000000;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt;padding:5px" align="left">'
                        + '<p style="margin-top: 0px;margin-bottom: 0;text-align:left;width: 100%;font-size: 16px;font-family:Arial">Vendor Name</p>'
                        + '</th>'
                        + '<th style="margin-bottom: 0px;color: #000000;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt;padding:5px" align="left">'
                        + '<p style="margin-top: 0px;margin-bottom: 0;text-align:left;width: 100%;font-size: 16px;font-family:Arial">Vendor PO No</p>'
                        + '</th>'
                        + '<th style="margin-bottom: 0px;color: #000000;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt;padding:5px" align="left">'
                        + '<p style="margin-top: 0px;margin-bottom: 0;text-align:left;width: 100%;font-size: 16px;font-family:Arial">Vendor PO Line Item No</p>'
                        + '</th>'
                        + '</tr>'
                    for (let i = 0; i < this.state.checkedArray.length; i++) {
                        const vendorElement = this.state.checkedArray[i];
                        VendorTable += '<tr>'
                            + '<td style="margin-bottom: 0px;color: #000000;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt;padding:5px" align="left">'
                            + '<p style="margin-top: 0px;margin-bottom: 0;text-align:left;width: 100%;font-size: 16px;font-family:Arial">' + this.state.Consignee.Name + '</p>'
                            + '</td>'
                            + '<td style="margin-bottom: 0px;color: #000000;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt;padding:5px" align="left">'
                            + '<p style="margin-top: 0px;margin-bottom: 0;text-align:left;width: 100%;font-size: 16px;font-family:Arial">' + this.state.tabledata1.find(elem => elem.PurchaseOrderLineId == vendorElement).SendToPOSAPID + '</p>'
                            + '</td>'
                            + '<td style="margin-bottom: 0px;color: #000000;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt;padding:5px" align="left">'
                            + '<p style="margin-top: 0px;margin-bottom: 0;text-align:left;width: 100%;font-size: 16px;font-family:Arial">' + this.state.tabledata1.find(elem => elem.PurchaseOrderLineId == vendorElement).VendorPOLineItemNo + '</p>'
                            + '</td>'
                            + '</tr>'
                    }
                    VendorTable += '</tbody></table>'
                } else {
                    CustomerTable += '<table width="100%" style="border-spacing:0;margin-top:20px;padding-left:20px;padding-right:20px;">'
                        + '<tbody>'
                        + '<tr>'
                        + '<th style="margin-bottom: 0px;color: #000000;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt;padding:5px" align="left">'
                        + '<p style="margin-top: 0px;margin-bottom: 0;text-align:left;width: 100%;font-size: 16px;font-family:Arial">Sl No</p>'
                        + '</th>'
                        + '<th style="margin-bottom: 0px;color: #000000;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt;padding:5px" align="left">'
                        + '<p style="margin-top: 0px;margin-bottom: 0;text-align:left;width: 100%;font-size: 16px;font-family:Arial">Customer PO</p>'
                        + '</th>'
                        + '<th style="margin-bottom: 0px;color: #000000;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt;padding:5px" align="left">'
                        + '<p style="margin-top: 0px;margin-bottom: 0;text-align:left;width: 100%;font-size: 16px;font-family:Arial">Customer Billing Schedule No</p>'
                        + '</th>'
                        + '<th style="margin-bottom: 0px;color: #000000;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt;padding:5px" align="left">'
                        + '<p style="margin-top: 0px;margin-bottom: 0;text-align:left;width: 100%;font-size: 16px;font-family:Arial">Customer Billing Schedule Description</p>'
                        + '</th>'
                        + '<th style="margin-bottom: 0px;color: #000000;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt;padding:5px" align="left">'
                        + '<p style="margin-top: 0px;margin-bottom: 0;text-align:left;width: 100%;font-size: 16px;font-family:Arial">Customer Billing Schedule Quantity</p>'
                        + '</th>'
                        + '<th style="margin-bottom: 0px;color: #000000;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt;padding:5px" align="left">'
                        + '<p style="margin-top: 0px;margin-bottom: 0;text-align:left;width: 100%;font-size: 16px;font-family:Arial">UOM</p>'
                        + '</th>'
                        + '</tr>'
                    for (let j = 0; j < this.state.checkedArray.length; j++) {
                        const customerElement = this.state.checkedArray[j];
                        CustomerTable += '<tr>'
                            + '<td style="margin-bottom: 0px;color: #000000;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt;padding:5px" align="left">'
                            + '<p style="margin-top: 0px;margin-bottom: 0;text-align:left;width: 100%;font-size: 16px;font-family:Arial">' + (j + 1) + '</p>'
                            + '</td>'
                            + '<td style="margin-bottom: 0px;color: #000000;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt;padding:5px" align="left">'
                            + '<p style="margin-top: 0px;margin-bottom: 0;text-align:left;width: 100%;font-size: 16px;font-family:Arial">' + this.state.tabledata1.find(elem => elem.PurchaseOrderLineId == customerElement).CustomerPo + '</p>'
                            + '</td>'
                            + '<td style="margin-bottom: 0px;color: #000000;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt;padding:5px" align="left">'
                            + '<p style="margin-top: 0px;margin-bottom: 0;text-align:left;width: 100%;font-size: 16px;font-family:Arial">' + this.state.tabledata1.find(elem => elem.PurchaseOrderLineId == customerElement).BillingScheduleNo + '</p>'
                            + '</td>'
                            + '<td style="margin-bottom: 0px;color: #000000;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt;padding:5px" align="left">'
                            + '<p style="margin-top: 0px;margin-bottom: 0;text-align:left;width: 100%;font-size: 16px;font-family:Arial">' + this.state.tabledata1.find(elem => elem.PurchaseOrderLineId == customerElement).BillScheduleDescription + '</p>'
                            + '</td>'
                            + '<td style="margin-bottom: 0px;color: #000000;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt;padding:5px" align="left">'
                            + '<p style="margin-top: 0px;margin-bottom: 0;text-align:left;width: 100%;font-size: 16px;font-family:Arial">' + this.state.tabledata1.find(elem => elem.PurchaseOrderLineId == customerElement).CustomerBillingScheduleQuantity + '</p>'
                            + '</td>'
                            + '<td style="margin-bottom: 0px;color: #000000;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt;padding:5px" align="left">'
                            + '<p style="margin-top: 0px;margin-bottom: 0;text-align:left;width: 100%;font-size: 16px;font-family:Arial">' + this.state.tabledata1.find(elem => elem.PurchaseOrderLineId == customerElement).UOM + '</p>'
                            + '</td>'
                            + '</tr>'
                    }
                    CustomerTable += '</tbody></table><p style="margin-top: 20px;margin-bottom: 0;padding-left:54px;text-align:left;width: 100%;font-size: 16px;font-family:Arial">Consist of</p>'
                }
            }
            if (this.state.checkedArray.length > 0) {
                BillingScheduleTable += '<table width="100%" style="border-spacing:0;margin-top:10px;padding-left:20px;padding-right:20px;">'
                    + '<tbody>'
                    + '<tr>'
                    + '<th style="margin-bottom: 0px;color: #000000;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt;padding:5px" align="left">'
                    + '<p style="margin-top: 0px;margin-bottom: 0;text-align:left;width: 100%;font-size: 16px;font-family:Arial">PO Line Item No</p>'
                    + '</th>'
                    + '<th style="margin-bottom: 0px;color: #000000;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt;padding:5px" align="left">'
                    + '<p style="margin-top: 0px;margin-bottom: 0;text-align:left;width: 100%;font-size: 16px;font-family:Arial">Billing Schedule No</p>'
                    + '</th>'
                    + '<th style="margin-bottom: 0px;color: #000000;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt;padding:5px" align="left">'
                    + '<p style="margin-top: 0px;margin-bottom: 0;text-align:left;width: 100%;font-size: 16px;font-family:Arial">Material No</p>'
                    + '</th>'
                    + '<th style="margin-bottom: 0px;color: #000000;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt;padding:5px" align="left">'
                    + '<p style="margin-top: 0px;margin-bottom: 0;text-align:left;width: 100%;font-size: 16px;font-family:Arial">Description</p>'
                    + '</th>'
                    + '<th style="margin-bottom: 0px;color: #000000;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt;padding:5px" align="left">'
                    + '<p style="margin-top: 0px;margin-bottom: 0;text-align:left;width: 100%;font-size: 16px;font-family:Arial">Qty</p>'
                    + '</th>'
                    + '<th style="margin-bottom: 0px;color: #000000;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt;padding:5px" align="left">'
                    + '<p style="margin-top: 0px;margin-bottom: 0;text-align:left;width: 100%;font-size: 16px;font-family:Arial">UOM</p>'
                    + '</th>'
                    + '<th style="margin-bottom: 0px;color: #000000;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt;padding:5px" align="left">'
                    + '<p style="margin-top: 0px;margin-bottom: 0;text-align:left;width: 100%;font-size: 16px;font-family:Arial">Assembly PO Ref </p>'
                    + '</th>'
                    + '<th style="margin-bottom: 0px;color: #000000;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt;padding:5px" align="left">'
                    + '<p style="margin-top: 0px;margin-bottom: 0;text-align:left;width: 100%;font-size: 16px;font-family:Arial">Remarks </p>'
                    + '</th>'
                    + '</tr>'
                var lineItem = []
                for (let k = 0; k < this.state.checkedArray.length; k++) {
                    const billingElement = this.state.checkedArray[k];
                    if (!lineItem.includes(billingElement)) {
                        lineItem.push(billingElement.PurchaseOrderLineId)
                        BillingScheduleTable += '<tr>'
                            + '<td style="margin-bottom: 0px;color: #000000;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt;padding:5px" align="left">'
                            + '<p style="margin-top: 0px;margin-bottom: 0;text-align:left;width: 100%;font-size: 16px;font-family:Arial"><b>' + this.state.BillingScheduleDetails.find(elem => elem.PurchaseOrderLineId == billingElement).POLineItemSAPCode + '</b></p>'
                            + '</td>'
                            + '<td style="margin-bottom: 0px;color: #000000;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt;padding:5px" align="left">'
                            + '<p style="margin-top: 0px;margin-bottom: 0;text-align:left;width: 100%;font-size: 16px;font-family:Arial"></p>'
                            + '</td>'
                            + '<td style="margin-bottom: 0px;color: #000000;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt;padding:5px" align="left">'
                            + '<p style="margin-top: 0px;margin-bottom: 0;text-align:left;width: 100%;font-size: 16px;font-family:Arial"><b>' + this.state.BillingScheduleDetails.find(elem => elem.PurchaseOrderLineId == billingElement).MaterialNumber + '</b></p>'
                            + '</td>'
                            + '<td style="margin-bottom: 0px;color: #000000;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt;padding:5px" align="left">'
                            + '<p style="margin-top: 0px;margin-bottom: 0;text-align:left;width: 100%;font-size: 16px;font-family:Arial"><b>' + this.state.BillingScheduleDetails.find(elem => elem.PurchaseOrderLineId == billingElement).POLineItemDescription + '</b></p>'
                            + '<p style="margin-top: 0px;margin-bottom: 0;text-align:left;width: 100%;font-size: 16px;font-family:Arial"><b>' + (this.state.BillingScheduleDetails.find(elem => elem.PurchaseOrderLineId == billingElement).BillingScheduleNo !== null ? 'Consist of' : '') + '</b></p>'
                            + '</td>'
                            + '<td style="margin-bottom: 0px;color: #000000;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt;padding:5px" align="left">'
                            + '<p style="margin-top: 0px;margin-bottom: 0;text-align:left;width: 100%;font-size: 16px;font-family:Arial"><b>' + this.state.tabledata1.find(elem => elem.PurchaseOrderLineId == billingElement).RequestedQuantity + '</b></p>'
                            + '</td>'
                            + '<td style="margin-bottom: 0px;color: #000000;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt;padding:5px" align="left">'
                            + '<p style="margin-top: 0px;margin-bottom: 0;text-align:left;width: 100%;font-size: 16px;font-family:Arial"><b>' + this.state.tabledata1.find(elem => elem.PurchaseOrderLineId == billingElement).OrderUnit + '</b></p>'
                            + '</td>'
                            + '<td style="margin-bottom: 0px;color: #000000;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt;padding:5px" align="left">'
                            + '<p style="margin-top: 0px;margin-bottom: 0;text-align:left;width: 100%;font-size: 16px;font-family:Arial"><b>' + (this.state.sendToValue === 'Vendor' ? this.state.tabledata1.find(elem => elem.PurchaseOrderLineId == billingElement).SendToPOSAPID + '-' + this.state.tabledata1.find(elem => elem.PurchaseOrderLineId == billingElement).VendorPOLineItemNo : this.state.tabledata1.find(elem => elem.PurchaseOrderLineId == billingElement).CustomerPo) + '</b></p>'
                            + '</td>'
                            + '<td style="margin-bottom: 0px;color: #000000;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt;padding:5px" align="left">'
                            + '<p style="margin-top: 0px;margin-bottom: 0;text-align:left;width: 100%;font-size: 16px;font-family:Arial"><b>' + this.state.tabledata1.find(elem => elem.PurchaseOrderLineId == billingElement).Remarks + '</b></p>'
                            + '</td>'
                            + '</tr>'
                    }
                    if (this.state.BillingScheduleDetails.find(elem => elem.PurchaseOrderLineId == billingElement).BillingScheduleNo !== null) {
                        BillingScheduleTable += '<tr>'
                            + '<td style="margin-bottom: 0px;color: #000000;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt;padding:5px" align="left">'
                            + '<p style="margin-top: 0px;margin-bottom: 0;text-align:left;width: 100%;font-size: 16px;font-family:Arial"></p>'
                            + '</td>'
                            + '<td style="margin-bottom: 0px;color: #000000;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt;padding:5px" align="left">'
                            + '<p style="margin-top: 0px;margin-bottom: 0;text-align:left;width: 100%;font-size: 16px;font-family:Arial">' + this.state.BillingScheduleDetails.find(elem => elem.PurchaseOrderLineId == billingElement).BillingScheduleNo + '</p>'
                            + '</td>'
                            + '<td style="margin-bottom: 0px;color: #000000;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt;padding:5px" align="left">'
                            + '<p style="margin-top: 0px;margin-bottom: 0;text-align:left;width: 100%;font-size: 16px;font-family:Arial"></p>'
                            + '</td>'
                            + '<td style="margin-bottom: 0px;color: #000000;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt;padding:5px" align="left">'
                            + '<p style="margin-top: 0px;margin-bottom: 0;text-align:left;width: 100%;font-size: 16px;font-family:Arial">' + this.state.BillingScheduleDetails.find(elem => elem.PurchaseOrderLineId == billingElement).BillingSchDescription + '</p>'
                            + '</td>'
                            + '<td style="margin-bottom: 0px;color: #000000;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt;padding:5px" align="left">'
                            + '<p style="margin-top: 0px;margin-bottom: 0;text-align:left;width: 100%;font-size: 16px;font-family:Arial">' + this.state.BillingScheduleDetails.find(elem => elem.PurchaseOrderLineId == billingElement).BillingSchQuantity + '</p>'
                            + '</td>'
                            + '<td style="margin-bottom: 0px;color: #000000;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt;padding:5px" align="left">'
                            + '<p style="margin-top: 0px;margin-bottom: 0;text-align:left;width: 100%;font-size: 16px;font-family:Arial">' + this.state.BillingScheduleDetails.find(elem => elem.PurchaseOrderLineId == billingElement).BillingSchUnit + '</p>'
                            + '</td>'
                            + '<td style="margin-bottom: 0px;color: #000000;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt;padding:5px" align="left">'
                            + '<p style="margin-top: 0px;margin-bottom: 0;text-align:left;width: 100%;font-size: 16px;font-family:Arial"></p>'
                            + '</td>'
                            + '</tr>'
                    }
                }
                BillingScheduleTable += '</tbody></table>'
            }
            html = html.replace(/{{POSAPId}}/g, this.state.selectedPOSAPId)
            html = html.replace(/{{POCreationDate}}/g, this.state.POCreationDate)
            html = html.replace(/{{VendorName}}/g, this.state.vendorName)
            html = html.replace(/{{SalesPerson}}/g, this.state.SalesPerson)
            html = html.replace(/{{consigneeName}}/g, this.state.Consignee.Name) //1
            html = html.replace(/{{consigneeAddress}}/g, this.state.Consignee.Address) //2
            html = html.replace(/{{ConsigneeGSTIN}}/g, this.state.Consignee.GSTIN) //3
            html = html.replace(/{{VendorAddress}}/g, ((this.state.VendorAddress && this.state.VendorAddress != '' ? this.state.VendorAddress + ", " : '') + (this.state.VendorState && this.state.VendorState != '' ? this.state.VendorState + ", " : '') + (this.state.VendorPin && this.state.VendorPin != '' ? this.state.VendorPin + ", " : '') + (this.state.VendorCountry && this.state.VendorCountry != '' ? this.state.VendorCountry : '')))
            html = html.replace(/{{DCIssueDate}}/g, dateFormater(new Date()))
            html = html.replace(/{{ActedEmail}}/g, AuthHandler.getUserPayLoad().email)
            html = html.replace(/{{TPMEmail}}/g, AuthHandler.getUserPayLoad().email)
            html = html.replace(/{{TPM}}/g, AuthHandler.getUserPayLoad().fullName)
            html = html.replace(/{{CustomerTable}}/g, CustomerTable)
            html = html.replace(/{{VendorTable}}/g, VendorTable)
            html = html.replace(/{{BillingScheduleTable}}/g, BillingScheduleTable)
        }
    

        await this.setState({ templateModal: !this.state.templateModal, templateDataPreview1: html });
        if (this.state.templateModal == true) {
            this.setState(
                { opacity: "" }
            )
        }
        else {
            this.setState(
                { opacity: "0.2" }
            )
        }
    }
    handleFileInput = async (event) => {
        let reviseForm = this.state.reviseForm
        reviseForm.file.push(event.target.files[0])
        this.setState({ reviseForm });
    }
    generateDc = async () => {
        let Consigne = { ...this.state.Consignee }
        if (this.state.sendToValue == "Vendor") {
            Consigne.Name = this.state.VendorName
            Consigne.Address = this.state.SendToVendorAddress
            Consigne.GSTIN = this.state.SendToVendorGSTIn
        }
        if (Consigne.Name == '') {
            let text = this.state.sendToValue == "Vendor" ? "Please Select Vendor" : "Please enter Consignee Name"
            swal(text, { icon: "error" })
            return false
        }
        if (Consigne.Address == '') {
            let text = this.state.sendToValue == "Vendor" ? "Please enter Vendor Address" : "Please enter Consignee Address"
            swal(text, { icon: "error" })
            return false
        }
        if (Consigne.GSTIN == '') {
            let text = this.state.sendToValue == "Vendor" ? "Please Select Vendor GSTIN" : "Please enter Consignee GSTIN"
            swal(text, { icon: "error" })
            return false
        }
        if (this.state.DCTemplate == '') {
            let text = "Please select a DC Template"
            swal(text, { icon: "error" })
            return false
        }
        if (this.state.SalesPerson == '') {
            let text = "Please enter Sales Person"
            swal(text, { icon: "error" })
            return false
        }
        if (this.state.checkedArray.length == 0) {
            let text = "Please select IC Line Item"
            swal(text, { icon: "error" })
            return false
        }
        for (let i = 0; i < this.state.checkedArray.length; i++) {
            if (this.state.tabledata1.find(elem => elem.PurchaseOrderLineId == this.state.checkedArray[i]).RequestedQuantity == 0) {
                let text = "Please enter present DC quantity against IC -" + this.state.tabledata1.find(elem => elem.PurchaseOrderLineId == this.state.checkedArray[i]).POSAPId + '-' + this.state.tabledata1.find(elem => elem.PurchaseOrderLineId == this.state.checkedArray[i]).POLineItemSAPCode
                swal(text, { icon: "error" })
                return false
            }
            if (this.state.tabledata1.find(elem => elem.PurchaseOrderLineId == this.state.checkedArray[i]).SendToPOSAPID && this.state.tabledata1.find(elem => elem.PurchaseOrderLineId == this.state.checkedArray[i]).SendToPOSAPID == '' && this.state.sendToValue == "Vendor") {
                let text = "Please select Vendor PO Number against IC -" + this.state.tabledata1.find(elem => elem.PurchaseOrderLineId == this.state.checkedArray[i]).POSAPId + '-' + this.state.tabledata1.find(elem => elem.PurchaseOrderLineId == this.state.checkedArray[i]).POLineItemSAPCode
                swal(text, { icon: "error" })
                return false
            }
            if (this.state.tabledata1.find(elem => elem.PurchaseOrderLineId == this.state.checkedArray[i]).VendorPOLineItemNo && this.state.tabledata1.find(elem => elem.PurchaseOrderLineId == this.state.checkedArray[i]).VendorPOLineItemNo == '' && this.state.sendToValue == "Vendor") {
                let text = "Please select Vendor PO Line Item Number against IC -" + this.state.tabledata1.find(elem => elem.PurchaseOrderLineId == this.state.checkedArray[i]).POSAPId + '-' + this.state.tabledata1.find(elem => elem.PurchaseOrderLineId == this.state.checkedArray[i]).POLineItemSAPCode
                swal(text, { icon: "error" })
                return false
            }
        }
        // console.log(Consigne, "this.state.Consignee")
        // return false
        await this.setState({ loading: true })
        let dcUniqueKey = "DC-" + Math.floor(Math.random() * 1000000000)
        let dcPoNo = ""+this.state.SelectedProjectCode+"-"+this.state.selectedPOSAPId+"-"+ `${this.state.DCLISTcountforPONO+1}` +"" 
        let documentId = 0
        for (let i = 0; i < this.state.checkedArray.length; i++) {
            // console.log(this.state.checkedArray[i],this.state.tabledata1,"LSKSKSKSKSK")
            // return false
            let templatedata = {
                RequestedQuantity: this.state.tabledata1.find(elem => elem.PurchaseOrderLineId == this.state.checkedArray[i]).RequestedQuantity,
                PoLineItemId: this.state.checkedArray[i],
                indicator: 3,
                issuedQuantity: 0,
                BillingSchNo: this.state.tabledata1.find(elem => elem.PurchaseOrderLineId == this.state.checkedArray[i]).BillingScheduleNo,
                BillingSchDescription: this.state.tabledata1.find(elem => elem.PurchaseOrderLineId == this.state.checkedArray[i]).BillScheduleDescription,
                // documentId: 0,
                documentId: documentId,
                ActedId: AuthHandler.getUserID(),
                Consignee: Consigne,
                dcUniqueKey: dcUniqueKey,
                dcPoNo: dcPoNo,
                CustomerPo: this.state.tabledata1.find(elem => elem.PurchaseOrderLineId == this.state.checkedArray[i]).CustomerPo,
                VendorName: this.state.sendToValue == "Vendor" ? this.state.VendorName : Consigne.Name,
                VendorPOLineItemNo: this.state.tabledata1.find(elem => elem.PurchaseOrderLineId == this.state.checkedArray[i]).VendorPOLineItemNo,
                VendorPONo: this.state.tabledata1.find(elem => elem.PurchaseOrderLineId == this.state.checkedArray[i]).SendToPOSAPID,
                CustomerBillingScheduleQuantity: this.state.tabledata1.find(elem => elem.PurchaseOrderLineId == this.state.checkedArray[i]).CustomerBillingScheduleQuantity,
                UOM: this.state.tabledata1.find(elem => elem.PurchaseOrderLineId == this.state.checkedArray[i]).UOM,
                Remarks: this.state.tabledata1.find(elem => elem.PurchaseOrderLineId == this.state.checkedArray[i]).Remarks,
                TemplateId: this.state.DCTemplate,
                SalesPerson: this.state.SalesPerson
            }
            // console.log(templatedata, "templatedata")
            await this.props.postDispatchClearenceDetails(templatedata)
        }
        await this.props.generateDispatchClearence({ DcId: dcUniqueKey, ActedEmail: AuthHandler.getUserPayLoad().email, TemplateData: this.state.templateDataPreview, sendTo: this.state.sendToValue, Consignee: Consigne, projectCode: this.state.SelectedProjectCode, RollId: parseInt(Object.keys(AuthHandler.getRoles())[0])})
        // await this.modal()
        await toast.success(`Data has been added`, {
            duration: 4000
        });
        setTimeout(async () => {
             // await this.props.history.push("DCListing")
             window.location.reload(false);
            await this.setState({ loading: false })
        }, 3000)
    }
    togglebutton = async (Index) => {
        // console.log("ooopopopop")
        var multiCollapseIndex = this.state.multiCollapseIndex
        if (multiCollapseIndex != Index || multiCollapseIndex == '') {
            await this.setState({ multiCollapseIndex: Index })
        }
        // console.log(this.state.multiCollapseIndex, "multiCollapseIndex")
    }
    generateDcModal = async () => {
        let checkedArrayok = true;
        if (this.state.selectedPoId === 0) {
            swal("Please Select a PO", { icon: "error" })
            return false;
        }
        if (this.state.checkedArray.length === 0) {
            swal("Please Select a LineItem", { icon: "error" })
            return false;
        }
        // console.log(this.state.checkedArray.length);

        await this.state.checkedArray.map((elem) => {
            if (this.state.tabledata.filter((data) => data.PurchaseOrderLineId == elem)[0].RequestedQuantity == null || this.state.tabledata.filter((data) => data.PurchaseOrderLineId == elem)[0].RequestedQuantity == 0) {
                checkedArrayok = false;
            }
        })
        if (!checkedArrayok) {
            swal("Present DC Field is empty for the selected row", { icon: "error" })
            return false;
        }
        await this.modal()
    }
    toggleFilter = async () => {
        this.setState({ isShowFilter: !this.state.isShowFilter })
    }
    handleSelectfilterpo = async (e) => {
        let filterByPOSAPId = []
        let ponumber = []
        if (e.length > 0) {
            e.map((item) => {
                filterByPOSAPId.push(item.value)
                ponumber.push(item)
            })
        }
        await this.setState({ filterByPOSAPId, ponumber })
        // console.log("this.state.filterByPOSAPId", this.state.filterByPOSAPId, this.state.ponumber)
        await this.dataSync()
    }
    handleSelectfiltervendor = async (e) => {
        let filterByVendorName = []
        let vendor = []
        if (e.length > 0) {
            e.map((item) => {
                filterByVendorName.push(item.value)
                vendor.push(item)
            })
        }
        // console.log(vendor, "abcd")
        await this.setState({ filterByVendorName, vendor })
        await this.dataSync()
    }

    handleSelectSendTo = async (e) => {
        let selectedSendTo = e.value
        await this.setState({ sendToValue: selectedSendTo })
    }
    // handleConsigneeName = (e) => {
    //     let Consignee = { ...this.state.Consignee }
    //     Consignee.Name = e.target.value
    //     this.setState({ Consignee })
    // }
    handleConsigneeAddress = (e) => {
        let Consignee = { ...this.state.Consignee }
        Consignee.Address = e.target.value
        this.setState({ Consignee })
    }
    handleConsigneeGSTIN = (e) => {
        let Consignee = { ...this.state.Consignee }
        Consignee.GSTIN = e.target.value
        this.setState({ Consignee })
    }
    handleSelectWBS = async (e) => {
        let sortByWBS = []
        let WBSCode = []
        if (e.length > 0) {
            e.map((item) => {
                sortByWBS.push(item.value)
                WBSCode.push(item)
            })
        }
        await this.setState({ sortByWBS, WBSCode })
        await this.dataSync()
    }
    handleSelectPlantCode = async (e) => {
        let sortByPlantCode = []
        let PlantCode = []
        if (e.length > 0) {
            e.map((item) => {
                sortByPlantCode.push(item.value)
                PlantCode.push(item)
            })
        }
        await this.setState({ sortByPlantCode, PlantCode })
        await this.dataSync()
    }
    clearFilter = async () => {
        if (new URLSearchParams(this.props.location.search).get("searchTerm") && new URLSearchParams(this.props.location.search).get("searchFor") == 'PO Number') {
            await this.props.history.push("DispatchClearanceTable")
        }
        await this.setState({
            isShowFilter: false,
            WBSCode: [],
            PlantCode: [],
            ponumber: [],
            vendor: [],
            filterByVendorName: [],
            filterByPOSAPId: [],
            sortByWBS: [],
            sortByPlantCode: [],
        })
        await this.dataSync()
    }
    handleVendorAddress = (e) => {
        let SendToVendorAddress = e.target.value
        let Consignee = { ...this.state.Consignee }
        Consignee.Address = SendToVendorAddress
        this.setState({ SendToVendorAddress, Consignee })
    }
    handleVendorGSTIN = (e) => {
        let SendToVendorGSTIn = e.target.value
        this.setState({ SendToVendorGSTIn })
    }
    handleSalesPerson = (e) => {
        let SalesPerson = e.target.value
        this.setState({ SalesPerson })
    }
    handleDCTemplate = async (e) => {
        let DCTemplate = e.value
        let DCTemplateLabel = e.label
        let templateDataPreview = e.templateData
        // console.log(templateDataPreview, e, 'templateDataPreview')
        await this.setState({ DCTemplate, DCTemplateLabel, templateDataPreview })
    }
    handleVendorName = async (e) => {
        let VendorName = e.value
        let VendorLabel = e.label
        // console.log(e, "abc")
        await this.setState({ VendorName, VendorLabel })
        let Consignee = { ...this.state.Consignee }
        let SendToVendorAddress = ''
        let SendToVendorGSTIn = ''
        let SalesPerson = ''
        let input = {
            VendorName: VendorName,
            PurchaseOrderId: this.state.SendToPurchaseOrderId,
            SelectedProjectCode: this.state.SelectedProjectCode
        }
        await this.props.VendorDetails(input)
        let vendorDetailsData = await this.props.dispatchOrderDetailsReducer.postVendorDetails.result.recordsets[0][0]
        let vendorPOData = await this.props.dispatchOrderDetailsReducer.postVendorDetails.result.recordsets[1]
        let vendorPOLineItems = await this.props.dispatchOrderDetailsReducer.postVendorDetails.result.recordsets[2]
        if (vendorDetailsData) {
            SendToVendorAddress =
                vendorDetailsData.VendorAddress +
                //  vendorDetailsData.VendorAddress1 ? ", " + vendorDetailsData.VendorAddress1 : '' +
                //  vendorDetailsData.VendorAddress2 ? ", " + vendorDetailsData.VendorAddress2 : '' +
                "- " + vendorDetailsData.VendorCity +
                ", " + vendorDetailsData.VendorLocation +
                ", " + vendorDetailsData.VendorState
            SendToVendorGSTIn = vendorDetailsData.VendorGstin
            // SalesPerson = vendorDetailsData.SalesPerson
        }
        Consignee.Name = VendorName
        Consignee.Address = SendToVendorAddress
        Consignee.GSTIN = SendToVendorGSTIn
        // console.log(SendToVendorAddress, SendToVendorGSTIn, "bnm")
        // console.log(vendorDetailsData, vendorPOData, vendorPOLineItems, "vendorDetailsData")
        // this.dataSync()
        await this.setState({
            SendToPurchaseOrderId: 0, SendToPOSAPID: '', VendorPOLineItemNo: '', VendorName, VendorLabel, vendorPOData
            , SendToVendorAddress, SendToVendorGSTIn, vendorPOLineItems, Consignee
        })
    }

    handleToVendorPONo = async (e, index) => {
        let SendToPurchaseOrderId = e.value
        let SendToPOSAPID = e.label
        let tabledata1 = [...this.state.tabledata1]
        tabledata1[index].SendToPOSAPID = SendToPOSAPID
        tabledata1[index].SendToPurchaseOrderId = SendToPurchaseOrderId
        // console.log(this.state.tabledata1[index], "abcd")
        let SendToVendorAddress = ''
        let SendToVendorGSTIn = ''
        await this.setState({ SendToPurchaseOrderId, SendToPOSAPID })
        let input = {
            VendorName: this.state.VendorName,
            PurchaseOrderId: this.state.SendToPurchaseOrderId,
            SelectedProjectCode: this.state.SelectedProjectCode
        }
        await this.props.VendorDetails(input)
        let vendorDetailsData = await this.props.dispatchOrderDetailsReducer.postVendorDetails.result.recordsets[0][0]
        let vendorPOData = await this.props.dispatchOrderDetailsReducer.postVendorDetails.result.recordsets[1]
        let vendorPOLineItems = await this.props.dispatchOrderDetailsReducer.postVendorDetails.result.recordsets[2]
        if (vendorDetailsData) {
            SendToVendorAddress =
                vendorDetailsData.VendorAddress +
                //  vendorDetailsData.VendorAddress1 ? ", " + vendorDetailsData.VendorAddress1 : '' +
                //  vendorDetailsData.VendorAddress2 ? ", " + vendorDetailsData.VendorAddress2 : '' +
                "- " + vendorDetailsData.VendorCity +
                ", " + vendorDetailsData.VendorLocation +
                ", " + vendorDetailsData.VendorState
            SendToVendorGSTIn = vendorDetailsData.VendorGstin
        }
        // console.log(SendToVendorAddress, SendToVendorGSTIn, "bnm")
        // console.log(vendorDetailsData, vendorPOData, vendorPOLineItems, "vendorDetailsData")
        // await this.dataSync()
        await this.setState({
            SendToPurchaseOrderId, vendorPOData, tabledata1
            , SendToVendorAddress, SendToVendorGSTIn, vendorPOLineItems
        })
    }

    handlepage = async (event) => {
        let offsetVal = this.state.offsetVal
        let currentPage = Number(event.target.id)
        if (!event.target.id) {
            currentPage = event.target.offsetParent.id
        }
        if (currentPage == 1) {
            offsetVal = 0
        }
        else {
            offsetVal = 10 * (currentPage - 1)
        }
        this.setState({ activepage: currentPage, offsetVal: offsetVal })
        let searchdata={};
        let tabledata1 = [];
        let tabledata=[];
        if(this.state.selectedPoId.length != 0 && this.state.selectedPoId ){
            searchdata = {
                userId: 0,
                filterByPOSAPId: this.state.filterByPOSAPId,
                filterByVendorName: this.state.filterByVendorName,
                sortByPlantCode: this.state.sortByPlantCode,
                sortByWBS: this.state.sortByWBS,
                PoNumber: this.state.selectedPoId,
                offsetVal: offsetVal,
                offsetVal1: this.state.offsetVal1,
                RowCount: this.state.RowCountPO,
            }
            await this.props.GetPOAndLineItemListForDispatchonPONumber(searchdata)
             tabledata1 = await this.props.dispatchOrderDetailsReducer.getPOAndLineItemListForDispatchonPONumber.recordset.filter(item => ((item.icqty - item.IssuedQuantity) - item.RequestedQuantity) != 0)
             this.setState({ tabledata1: tabledata1})
        }
        else{
            searchdata = {
                userId: 0,
                filterByPOSAPId: this.state.filterByPOSAPId,
                filterByVendorName: this.state.filterByVendorName,
                sortByPlantCode: this.state.sortByPlantCode,
                sortByWBS: this.state.sortByWBS,
                offsetVal: offsetVal,
                RowCount: this.state.RowCount,
            }
        await this.props.GetPOAndLineItemListForDispatch(searchdata)
        let tabledata = await this.props.dispatchOrderDetailsReducer.getPOAndLineItemDetails.recordset.filter(item => ((item.icqty - item.IssuedQuantity) - item.RequestedQuantity) != 0)
        this.setState({ tabledata: tabledata})
        }
    }
    handlepage1 = async (event) => {
        let offsetVal1 = this.state.offsetVal1
        let currentPage = Number(event.target.id)
        let iclistData;
        if (!event.target.id) {
            currentPage = event.target.offsetParent.id
        }

        if (currentPage == 1) {
            offsetVal1 = 0
        }
        else {
            offsetVal1 = 10 * (currentPage - 1)
        }
        this.setState({ activepage1: currentPage, offsetVal1: offsetVal1 })
        let searchdata = {
            userId: 0,
            filterByPOSAPId: this.state.filterByPOSAPId,
            filterByVendorName: this.state.filterByVendorName,
            sortByPlantCode: this.state.sortByPlantCode,
            sortByWBS: this.state.sortByWBS,
            offsetVal1: offsetVal1,
            RowCount: this.state.RowCount,
        }
        await this.props.GetPOAndLineItemListForDispatchICListing(searchdata)
        if (this.props.dispatchOrderDetailsReducer.getPOAndLineItemDetailsInspectionDetails.recordset && this.props.dispatchOrderDetailsReducer.getPOAndLineItemDetailsInspectionDetails.recordset.length > 0) {
            iclistData = this.props.dispatchOrderDetailsReducer.getPOAndLineItemDetailsICListing.recordset.filter(item => ((item.icqty - item.IssuedQuantity) - item.RequestedQuantity) == 0)
        }
        this.setState({ iclistData: iclistData })
    }


    render() {
        // console.log("jhgvfvds",this.state.templateDataPreview1)
        const customerName = this.state.tableCustomer.map(row=>({value: row.CustomerName, label:row.CustomerName}))
        const customerAddress = this.state.tableCustomer.map((row)=>{
            if(row.CustomerName===this.state.Consignee.Name){
                this.state.Consignee.Address=row.CustomerAddress
                this.state.Consignee.GSTIN=row.GSTIN

            }
        })
        // console.log("opopopopop", this.state.Consignee)
        // console.log("popopopo", AuthHandler.getUserPayLoad().email)
        var roles = AuthHandler.getRoles()
        const { selectedOption } = this.state;
        const dropDownArray = [...this.state.dropDownArray];
        const customStyles = {
            option: (provided, state) => ({
                ...provided,
                borderBottom: '1px dotted pink',
                //   color: state.isSelected ? 'red' : 'blue',
                padding: "2px 10px",
            }),
            menu: (provided, state) => ({
                ...provided,
                width: "100%",
                minWidth: "max-content",
                zIndex: "999 !important",
            }),
        }

        const pageNumbers = [];

        if(this.state.tabledata1.length>0){
            console.log("sdbfjdsbsjf")
            for (let i = 1; i <= Math.ceil(this.state.totalrowcountPO / this.state.RowCountPO); i++) {
                pageNumbers.push(i);
            } 
        }
        else{
        for (let i = 1; i <= Math.ceil(this.state.totalrowcount / this.state.RowCount); i++) {
            pageNumbers.push(i);
        }}

        const pageNumbers1 = [];
        for (let i = 1; i <= Math.ceil(this.state.totalrowcount2 / this.state.RowCount); i++) {
            pageNumbers1.push(i);
        }

        const pageNumbersPo = [];
        for (let i = 1; i <= Math.ceil(this.state.totalrowcountPO / this.state.RowCount); i++) {
            pageNumbersPo.push(i);
        }


        console.log(pageNumbersPo, " jgvdhvfjdsfjfvsfjsv")

        // handlepagecount = ()=> {
        //    let arr = []
        //    let pagecount = (this.state.totalrowcount)/10;
        //     for(let i=0; i<pagecount; i++){
        //       arr[i] = i+1;
        //     }

        //     return(
        //         arr.map((item)=>
        //             <Pagination.Item active={item==this.state.activepage} onClick={() => this.handlepage(item)}>{item}</Pagination.Item>
        //         )
        //     )
        // }

        const handlepagecount = pageNumbers.map((number, index) => {
            let totalPages = pageNumbers.length
            if (index === 0) {
                return (
                    <>
                        <Pagination.First
                            key={"firstpage"}
                            id={number}
                            onClick={
                                this.state.activepage === number
                                    ? () => { }
                                    : (e) => {
                                        this.handlepage(e);
                                    }
                            }
                        />
                        <Pagination.Prev
                            key={"prevpage"}
                            id={this.state.activepage - 1}
                            onClick={
                                this.state.activepage === number
                                    ? () => { }
                                    : (e) => {
                                        this.handlepage(e);
                                    }
                            }
                        />
                        <Pagination.Item
                            key={number}
                            active={this.state.activepage === number ? true : false}
                            id={number}
                            onClick={
                                this.state.activepage === number
                                    ? () => { }
                                    : (e) => {
                                        this.handlepage(e);
                                    }
                            }
                        >
                            {number}
                        </Pagination.Item>
                    </>
                );
            }
            if (this.state.activepage <= 5) {
                if (number <= 8) {
                    return (
                        <>
                            <Pagination.Item
                                key={number}
                                active={this.state.activepage === number ? true : false}
                                id={number}
                                onClick={
                                    this.state.activepage === number
                                        ? () => { }
                                        : (e) => {
                                            this.handlepage(e);
                                        }
                                }
                            >
                                {number}
                            </Pagination.Item>
                        </>
                    );
                }
                if (number === 9) {
                    return (
                        <Pagination.Ellipsis key={number} />
                    )
                }
            }
            else if (totalPages - this.state.activepage <= 4) {
                if ((totalPages - 8) === number) {
                    return (
                        <Pagination.Ellipsis key={number} />
                    )
                }
                if ((totalPages - 7) === number || (totalPages - 6) === number || (totalPages - 5) === number || (totalPages - 4) === number || (totalPages - 3) === number || (totalPages - 2) === number || (totalPages - 1) === number) {
                    return (
                        <Pagination.Item
                            key={number}
                            active={this.state.activepage === number ? true : false}
                            id={number}
                            onClick={
                                this.state.activepage === number
                                    ? () => { }
                                    : (e) => {
                                        this.handlepage(e);
                                    }
                            }
                        >
                            {number}
                        </Pagination.Item>
                    )
                }

            } else {
                if ((this.state.activepage - 4) === number) {
                    return (
                        <Pagination.Ellipsis key={number} />
                    )
                }
                if ((this.state.activepage - 3) === number || (this.state.activepage - 2) === number || (this.state.activepage - 1) === number || this.state.activepage === number || (this.state.activepage + 1) === number || (this.state.activepage + 2) === number || (this.state.activepage + 3) === number) {
                    return (
                        <Pagination.Item
                            key={number}
                            active={this.state.activepage === number ? true : false}
                            id={number}
                            onClick={
                                this.state.activepage === number
                                    ? () => { }
                                    : (e) => {
                                        this.handlepage(e);
                                    }
                            }
                        >
                            {number}
                        </Pagination.Item>
                    )
                }
                if ((this.state.activepage + 4) === number) {
                    return (
                        <Pagination.Ellipsis key={number} />
                    )
                } else {
                    return ""
                }
            }
            if (index === totalPages - 1) {
                return (
                    <>
                        <Pagination.Item
                            key={totalPages}
                            active={this.state.activepage === number ? true : false}
                            id={totalPages}
                            onClick={
                                this.state.activepage === number
                                    ? () => { }
                                    : (e) => {
                                        this.handlepage(e);
                                    }
                            }
                        >
                            {totalPages}
                        </Pagination.Item>
                        <Pagination.Next
                            key={"nextpage"}
                            id={this.state.activepage + 1}
                            onClick={
                                this.state.activepage === number
                                    ? () => { }
                                    : (e) => {
                                        this.handlepage(e);
                                    }
                            }
                        />
                        <Pagination.Last
                            key={"lastpage"}
                            id={totalPages}
                            onClick={
                                this.state.activepage === number
                                    ? () => { }
                                    : (e) => {
                                        this.handlepage(e);
                                    }
                            }
                        />
                    </>
                )
            } else {
                return ""
            }
        });
    
        
    
    
        // handlepagecount1 = ()=> {
        //    let arr = []
        //    let pagecount = (this.state.totalrowcount2)/10;
        //    let pagetoShow
        //    for(let i=0; i<pagecount; i++){
        //        arr[i] = i+1;
        //     }
        //     return(
        //         <>
        //           <Pagination.Item/>
        //           {arr.map((item)=>
        //             <Pagination.Item active={item==this.state.activepage1} onClick={() => this.handlepage1(item)}>{item}</Pagination.Item>
        //           )}
        //         </>       
        //     )
        // }

        const handlepagecount1 = pageNumbers1.map((number, index) => {
            let totalPages = pageNumbers1.length
            if (index === 0) {
                return (
                    <>
                        <Pagination.First
                            key={"firstpage"}
                            id={number}
                            onClick={
                                this.state.activepage1 === number
                                    ? () => { }
                                    : (e) => {
                                        this.handlepage1(e);
                                    }
                            }
                        />
                        <Pagination.Prev
                            key={"prevpage"}
                            id={this.state.activepage1 - 1}
                            onClick={
                                this.state.activepage1 === number
                                    ? () => { }
                                    : (e) => {
                                        this.handlepage1(e);
                                    }
                            }
                        />
                        <Pagination.Item
                            key={number}
                            active={this.state.activepage1 === number ? true : false}
                            id={number}
                            onClick={
                                this.state.activepage1 === number
                                    ? () => { }
                                    : (e) => {
                                        this.handlepage1(e);
                                    }
                            }
                        >
                            {number}
                        </Pagination.Item>
                    </>
                );
            }
            if (this.state.activepage1 <= 5) {
                if (number <= 8) {
                    return (
                        <>
                            <Pagination.Item
                                key={number}
                                active={this.state.activepage1 === number ? true : false}
                                id={number}
                                onClick={
                                    this.state.activepage1 === number
                                        ? () => { }
                                        : (e) => {
                                            this.handlepage1(e);
                                        }
                                }
                            >
                                {number}
                            </Pagination.Item>
                        </>
                    );
                }
                if (number === 9) {
                    return (
                        <Pagination.Ellipsis key={number} />
                    )
                }
            }
            else if (totalPages - this.state.activepage1 <= 4) {
                if ((totalPages - 8) === number) {
                    return (
                        <Pagination.Ellipsis key={number} />
                    )
                }
                if ((totalPages - 7) === number || (totalPages - 6) === number || (totalPages - 5) === number || (totalPages - 4) === number || (totalPages - 3) === number || (totalPages - 2) === number || (totalPages - 1) === number) {
                    return (
                        <Pagination.Item
                            key={number}
                            active={this.state.activepage1 === number ? true : false}
                            id={number}
                            onClick={
                                this.state.activepage1 === number
                                    ? () => { }
                                    : (e) => {
                                        this.handlepage1(e);
                                    }
                            }
                        >
                            {number}
                        </Pagination.Item>
                    )
                }

            } else {
                if ((this.state.activepage1 - 4) === number) {
                    return (
                        <Pagination.Ellipsis key={number} />
                    )
                }
                if ((this.state.activepage1 - 3) === number || (this.state.activepage1 - 2) === number || (this.state.activepage1 - 1) === number || this.state.activepage1 === number || (this.state.activepage1 + 1) === number || (this.state.activepage1 + 2) === number || (this.state.activepage1 + 3) === number) {
                    return (
                        <Pagination.Item
                            key={number}
                            active={this.state.activepage1 === number ? true : false}
                            id={number}
                            onClick={
                                this.state.activepage1 === number
                                    ? () => { }
                                    : (e) => {
                                        this.handlepage1(e);
                                    }
                            }
                        >
                            {number}
                        </Pagination.Item>
                    )
                }
                if ((this.state.activepage1 + 4) === number) {
                    return (
                        <Pagination.Ellipsis key={number} />
                    )
                } else {
                    return ""
                }
            }
            if (index === totalPages - 1) {
                return (
                    <>
                        <Pagination.Item
                            key={totalPages}
                            active={this.state.activepage1 === number ? true : false}
                            id={totalPages}
                            onClick={
                                this.state.activepage1 === number
                                    ? () => { }
                                    : (e) => {
                                        this.handlepage1(e);
                                    }
                            }
                        >
                            {totalPages}
                        </Pagination.Item>
                        <Pagination.Next
                            key={"nextpage"}
                            id={this.state.activepage1 + 1}
                            onClick={
                                this.state.activepage1 === number
                                    ? () => { }
                                    : (e) => {
                                        this.handlepage1(e);
                                    }
                            }
                        />
                        <Pagination.Last
                            key={"lastpage"}
                            id={totalPages}
                            onClick={
                                this.state.activepage1 === number
                                    ? () => { }
                                    : (e) => {
                                        this.handlepage1(e);
                                    }
                            }
                        />
                    </>
                )
            } else {
                return ""
            }
        });



        if (this.state.loading) {
            return (
                <div className="backdrop">
                    <Loading />
                </div>
            )
        }
        return (
            <>
                {this.state.templateModal ?
                    <>
                        {this.state.loading ?
                            <div className="backdrop">
                                <Loading />
                            </div>
                            :
                            <>
                                <div style={{ position: 'fixed', width: '100%', zIndex: '100', backgroundColor: 'white', boxShadow: '0px 0px 5px 1px' }}>
                                    <button className='btn2 btn-sms1 mt-2 ml-2 float-left rounded-pill' onClick={() => this.previewTemplate()}><i class="fa fa-arrow-left"></i>&nbsp;&nbsp;Back</button>
                                    <span style={{ justifyContent: 'center', display: 'flex', fontSize: '19px', position: 'absolute', alignItems: 'center', marginLeft: '41%', marginTop: '6px' }}>Dispatch Clearence Preview</span>
                                    <button className="btn2 btn-sms1 rounded-pill mt-2 mr-4 float-right" type="submit" onClick={() => this.generateDc()}>Send To Vendor&nbsp;&nbsp;<i class="fa fa-arrow-right"></i></button>
                                </div>
                                <div className='page'>
                                    {parse(this.state.templateDataPreview1)}
                                </div>
                            </>}
                    </>
                    :
                    <div className="w-60 mx-auto shadow">
                        <Modal isOpen={this.state.modal} className="modal-md">
                            <div className="modalheads">
                                <ModalHeader HeaderStyle="modal-header ">
                                    <div className="modal-text"><h4>Upload Documents</h4></div>
                                    <button type="button" className="close" aria-label="Close" onClick={this.modal} >
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </ModalHeader>
                            </div>
                            <ModalBody Style="modal-body">
                                <div className="row mt-4">
                                    <div className="col-md-6">Dispatch Clearence:</div>
                                    <div className="col-md-6"><input id="FileDispatch" type="file" onChange={(e) => this.handleFileInput(e)} className="form-control-file" /></div>
                                </div>
                            </ModalBody>
                            <div className="">
                                <ModalFooter FooterStyle="modal-footer ">
                                    <div>
                                        <button className="btn2 btn-sms1 mt-2 ml-2 float-right rounded-pill" type="submit" onClick={this.generateDc}>Submit</button>
                                        <button className="btn2 btn-sms1 mt-2 ml-2 rounded-pill" onClick={this.modal} type="submit">Close</button>
                                    </div>
                                </ModalFooter>
                            </div>
                        </Modal>
                        {/* <Modal isOpen={this.state.templateModal} className="modal-lg">
                    <div className="modalheads">
                        <ModalHeader HeaderStyle="modal-header ">
                            <div className="modal-text"><h4>Template Preview</h4></div>
                            <button type="button" className="close" aria-label="Close" onClick={() => this.previewTemplate()} >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </ModalHeader>
                    </div>
                    <ModalBody Style="modal-body modalbodysWide-templateView">
                        <div className="row wrap mt-4">
                            {this.state.templateDataPreview ? parse(this.state.templateDataPreview) : ''}
                        </div>
                    </ModalBody>
                </Modal> */}
                        <div className="container mt-4 justify-content-between border-radius-modal border-color filter-data">
                            <div className="col-2 float-right" style={{ marginTop: '18px' }}>
                                <InputGroup >
                                    <FormControl style={{ cursor: 'unset' }} className='outline-primary' type="text" readOnly placeholder="Filter" />
                                    <InputGroup.Append>
                                        <Button onClick={() => this.toggleFilter()} variant="outline-primary"><FontAwesomeIcon icon={"filter"} /></Button>
                                    </InputGroup.Append>
                                    <InputGroup.Append>
                                        <Button onClick={(e) => this.clearFilter(e)} title='Clear All Filter' variant="outline-primary"><FontAwesomeIcon icon={"times"} size="lg" /></Button>
                                    </InputGroup.Append>
                                </InputGroup>
                            </div>
                            {this.state.isShowFilter ?
                                <div className="row justify-content-between pb-3 pt-3 m-0 filter-data pr-2 pl-2">
                                    <div className="col">
                                        <Select maxMenuHeight={500} placeholder="Project No." isMulti value={this.state.WBSCode} mode="multiple" hideSelectedOptions={false} closeMenuOnSelect={false} tabSelectsValue={false} controlShouldRenderValue={false} styles={customStyles} options={this.state.finalwbsno} onChange={(e) => this.handleSelectWBS(e)} />
                                    </div>
                                    <div className="col">
                                        <Select maxMenuHeight={500} placeholder="Plant" isMulti value={this.state.PlantCode} mode="multiple" hideSelectedOptions={false} closeMenuOnSelect={false} tabSelectsValue={false} controlShouldRenderValue={false} styles={customStyles} options={this.state.finalplantcode} onChange={(e) => this.handleSelectPlantCode(e)} />
                                    </div>
                                    <div className="col">
                                        <Select maxMenuHeight={500} placeholder="PO Number" isMulti value={this.state.ponumber} mode="multiple" hideSelectedOptions={false} closeMenuOnSelect={false} tabSelectsValue={false} controlShouldRenderValue={false} styles={customStyles} options={this.state.dropDownArrayPoNumber} onChange={(e) => this.handleSelectfilterpo(e)} />
                                    </div>
                                    <div className="col">
                                        <Select maxMenuHeight={500} placeholder="Vendor" isMulti value={this.state.vendor} mode="multiple" hideSelectedOptions={false} closeMenuOnSelect={false} tabSelectsValue={false} controlShouldRenderValue={false} styles={customStyles} options={this.state.dropDownArrayVendor} onChange={(e) => this.handleSelectfiltervendor(e)} />
                                    </div>
                                </div>
                                : null}
                            {roles[12] || roles[32] || roles[33] ?
                                <div class="float-right" style={{ marginTop: '15px' }}>
                                    {/* <button className="btn2 btn-sms1 rounded-pill mt-2 ml-4 float-right" type="submit" onClick={() => this.generateDcModal()}>Generate DC</button> */}
                                    {/* <button className="btn2 btn-sms1 rounded-pill mt-2 ml-4 float-right" type="submit" onClick={() => this.generateDc()}>Generate DC</button> */}
                                    <button className="btn2 btn-sms1 rounded-pill mt-2 ml-4 float-right" type="submit" onClick={() => this.previewTemplate()} disabled={this.state.DCTemplate ? false : true}>Preview</button>
                                </div>
                                :
                                null
                            }
                            {/* <CSVLink className="btn2 btn-sms1 rounded-pill ml-4 float-right" data={this.state.csvData} filename={'IC_List.csv'} style={{ marginTop: '24px' }}>Export</CSVLink> */}
                            <div className="row">
                                <div className="col-md-4" style={{ paddingLeft: 'inherit' }}>
                                    <b><label for="exampleInputEmail1" class="form-label">PO Number</label></b>
                                    <Select maxMenuHeight={500} placeholder="Purchase Orders" value={{ label: this.state.selectedPOSAPId }} styles={customStyles} options={this.state.dropDownArray} onChange={(e) => this.handleSelectPOs(e)} />
                                </div>
                                <div className="col-md-4">
                                    <b><label for="exampleInputEmail1" class="form-label">Vendor Name</label></b>
                                    <p><span>{this.state.vendorName}</span></p>
                                </div>
                                <div className="col-md-4">
                                    <b><label for="exampleInputEmail1" class="form-label">Vendor Location</label></b>
                                    <p><span>{this.state.VendorState && this.state.VendorCountry ? `${this.state.VendorState}, ${this.state.VendorCountry}` : null}</span></p>
                                </div>
                            </div>
                            <div className='row'>
                                <div className="col-md-4">
                                    <b><label for="exampleInputEmail1" class="form-label">Send to</label></b>
                                    <Select maxMenuHeight={500} placeholder="Purchase Orders" value={{ label: this.state.sendToValue }} styles={customStyles} options={this.state.sendTo} onChange={(e) => this.handleSelectSendTo(e)} />
                                </div>
                                {this.state.sendToValue == "Customer" ?
                                    <>
                                        <div className="col-md-4">
                                            <b><label for="exampleInputEmail1" class="form-label">Consignee Name:</label></b>
                                            {this.state.selectedPoId !== 0 ?
                                                 <Select maxMenuHeight={500} value={{ label: this.state.Consignee.Name }} styles={customStyles} options={customerName} onChange={(e) => this.handleConsigneeName(e)} />
                                                : <span className='badge' style={{ display: 'flex', color: 'red', fontSize: 'inherit', marginTop: '4px' }}>Please Select a PO</span>}
                                        </div>
                                        <div className="col-md-4">
                                            <b><label for="exampleInputEmail1" class="form-label">Consignee Address:</label></b>
                                            {this.state.selectedPoId !== 0 ?
                                                <textarea id="FileDispatch1" name='Consignee Address' value={this.state.Consignee.Address} onChange={(e) => this.handleConsigneeAddress(e)} className="form-control" />
                                                : <span className='badge' style={{ display: 'flex', color: 'red', fontSize: 'inherit', marginTop: '4px' }}>Please Select a PO</span>}
                                        </div>
                                        <div className="col-md-4">
                                            <b><label for="exampleInputEmail1" class="form-label">Consignee GSTIN</label></b>
                                            {this.state.selectedPoId !== 0 ?
                                                <input id="FileDispatch1" type="text" name='Consignee GSTIN' value={this.state.Consignee.GSTIN} onChange={(e) => this.handleConsigneeGSTIN(e)} className="form-control" disabled />
                                                : <span className='badge' style={{ display: 'flex', color: 'red', fontSize: 'inherit', marginTop: '4px' }}>Please Select a PO</span>}
                                        </div>
                                    </>
                                    : null}
                                {this.state.sendToValue == "Vendor" ?
                                    <>
                                        <div className="col-md-4">
                                            <b><label for="exampleInputEmail1" class="form-label">Vendor Name:</label></b>
                                            {this.state.selectedPoId !== 0 ?
                                                <Select maxMenuHeight={500} value={{ label: this.state.VendorLabel }} styles={customStyles} options={this.state.dropDownArrayVendor} onChange={(e) => this.handleVendorName(e)} />
                                                : <span className='badge' style={{ display: 'flex', color: 'red', fontSize: 'inherit', marginTop: '4px' }}>Please Select a PO</span>}
                                        </div>
                                        <div className="col-md-4">
                                            <b><label for="exampleInputEmail1" class="form-label">Vendor Details:</label></b>
                                            {this.state.selectedPoId !== 0 ?
                                                <textarea id="FileDispatch1" name='Vendor Details' value={this.state.SendToVendorAddress} onChange={(e) => this.handleVendorAddress(e)} className="form-control" />
                                                : <span className='badge' style={{ display: 'flex', color: 'red', fontSize: 'inherit', marginTop: '4px' }}>Please Select a PO</span>}
                                        </div>
                                        <div className="col-md-4">
                                            <b><label for="exampleInputEmail1" class="form-label">Vendor GSTIN</label></b>
                                            {this.state.selectedPoId !== 0 ?
                                                <input id="FileDispatch1" type="text" name='Vendor GSTIN' value={this.state.SendToVendorGSTIn} disabled onChange={(e) => this.handleVendorGSTIN(e)} className="form-control" />
                                                : <span className='badge' style={{ display: 'flex', color: 'red', fontSize: 'inherit', marginTop: '4px' }}>Please Select a PO</span>}
                                        </div>
                                    </>
                                    : null}
                                <div className="col-md-4">
                                    <b><label for="exampleInputEmail1" class="form-label">Sales Person</label></b>
                                    {this.state.selectedPoId !== 0 ?
                                        <input id="FileDispatch1" type="text" name='Vendor GSTIN' value={this.state.SalesPerson} onChange={(e) => this.handleSalesPerson(e)} className="form-control" />
                                        : <span className='badge' style={{ display: 'flex', color: 'red', fontSize: 'inherit', marginTop: '4px' }}>Please Select a PO</span>}
                                </div>
                                <div className="col-md-4">
                                    <b><label for="exampleInputEmail1" class="form-label">DC Template</label></b>
                                    {this.state.selectedPoId !== 0 ?
                                        <Select maxMenuHeight={500} placeholder="DC Template" value={{ label: this.state.DCTemplateLabel }} styles={customStyles} options={this.state.templateDataArray1} onChange={(e) => this.handleDCTemplate(e)} />
                                        : <span className='badge' style={{ display: 'flex', color: 'red', fontSize: 'inherit', marginTop: '4px' }}>Please Select a PO</span>}
                                </div>
                                {/* <div className='col'>
                        {this.state.DCTemplate ?
                            <button className="btn2 btn-sms1 rounded-pill mt-2 ml-4 float-right" type="submit" onClick={() => this.previewTemplate()}>Preview</button>
                            : ''
                        }
                    </div> */}

                            </div>
                        </div>
                        <div>
                            <div className="sticky">
                                <div className="wrap dispatch-clearance">
                                    <table class="table table-bordered mt-4">
                                        <thead class="table sticky-inner" style={{ backgroundColor: "#0989CB", color: "white" }}>
                                            <tr>
                                                {this.state.tabledata1.length > 0 && roles[12] || this.state.tabledata1.length > 0 && roles[32] || this.state.tabledata1.length > 0 && roles[33] ?
                                                    <th scope="col">
                                                        <input type="checkbox" onClick={this.handleChange} checked={this.state.select} />
                                                    </th>
                                                    : null}
                                                <th scope="col">Project Number</th>
                                                <th scope="col">PO Line item Description</th>
                                                <th scope="col" >IC Number</th>
                                                <th scope="col">Vendor Name</th>
                                                <th scope="col">PO Number</th>
                                                <th scope="col" >PO Line item no</th>
                                                <th scope="col" >IC qty</th>
                                                <th scope="col" >Qty already Issued DC</th>
                                                <th scope="col" >Balance Qty available for DC</th>
                                                <th scope="col" style={{ minWidth: '102px' }} >Present DC</th>
                                                <th scope="col">Remaining</th>
                                                {this.state.sendToValue == "Customer" ?
                                                    <th scope="col">Customer PO No</th>
                                                    : null}
                                                {this.state.sendToValue == "Customer" ?
                                                    <th scope="col">Customer Billing schedule No</th>
                                                    : null}
                                                {this.state.sendToValue == "Customer" ?
                                                    <th scope="col">Customer Billing Schedule Description</th>
                                                    : null}
                                                {this.state.sendToValue == "Customer" ?
                                                    <th scope="col">Customer Billing Schedule Quantity</th>
                                                    : null}
                                                {this.state.sendToValue == "Vendor" ?
                                                    <th style={{ minWidth: '300px !important' }}>To Vendor PO No</th>
                                                    : null}
                                                {this.state.sendToValue == "Vendor" ?
                                                    <th style={{ minWidth: '300px !important' }}>Vendor PO LineItem No</th>
                                                    : null}
                                                {this.state.sendToValue == "Customer" ?
                                                    <th scope="col">UOM</th>
                                                    : null}
                                                <th scope="col">Remarks</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.tabledata1.length > 0 ?
                                                this.state.tabledata1.map((item, index) => {
                                                    return (
                                                        <>
                                                            <tr onClick={() => this.togglebutton(index)} data-toggle="collapse" data-target={`.multi-collapse${index}`}>
                                                                {this.state.tabledata1.length > 0 && roles[12] || (this.state.tabledata1.length > 0 && roles[32]) || (this.state.tabledata1.length > 0 && roles[33]) ?
                                                                    <td scope="row">
                                                                        <input type="checkbox"
                                                                            checked={this.state.checkedArray.includes(item.PurchaseOrderLineId) ? true : false}
                                                                            disabled={item.IssuedQuantity == item.icqty ? true : false}
                                                                            onChange={() => this.handleSingleCheckBoxChange(item.PurchaseOrderLineId)} />
                                                                    </td>
                                                                    :
                                                                    null
                                                                }
                                                                <td>{item.WBSCode ? item.WBSCode.includes('ET') ? (item.WBSCode).slice(0, 11) : (item.WBSCode).slice(0, 6) : "Other"}</td>
                                                                <td>{item.POLineItemDescription}</td>
                                                                <td>{`IC-${item.POSAPId}-${item.POLineItemSAPCode}` + (item.POServiceLineItemSAPCode && "-" + item.POServiceLineItemSAPCode)}</td>
                                                                <td>{item.VendorName}</td>
                                                                <td>{item.POSAPId}</td>
                                                                <td>{item.POServiceLineItemSAPCode ? item.POServiceLineItemSAPCode : item.POLineItemSAPCode}</td>
                                                                <td>{(item.icqty).toFixed(2) + " " + item.OrderUnit}</td>
                                                                <td>{item.IssuedQuantity == null ? 0 : item.IssuedQuantity}{" " + item.OrderUnit}</td>
                                                                <td>{item.IssuedQuantity == null ? (item.icqty - 0).toFixed(2) : (item.icqty - item.IssuedQuantity).toFixed(2)}{" " + item.OrderUnit}</td>
                                                                <td>
                                                                    <input type="number" class="form-control"
                                                                        onChange={(e) => this.handlePDCInput(e, index, 2)}
                                                                        disabled={(roles[12] && item.IssuedQuantity == item.icqty) || (roles[32] && item.IssuedQuantity == item.icqty) || (roles[33] && item.IssuedQuantity == item.icqty) ? true : false}
                                                                        value={item.RequestedQuantity ? item.RequestedQuantity : 0} />

                                                                </td>
                                                                <td>{item.IssuedQuantity == null ? ((item.icqty - 0) - item.RequestedQuantity).toFixed(2) : ((item.icqty - item.IssuedQuantity) - item.RequestedQuantity).toFixed(2)}{" " + item.OrderUnit}</td>
                                                                {this.state.sendToValue == "Customer" ?
                                                                    <td><input type="text" value={item.CustomerPo ? item.CustomerPo : ""}
                                                                        onChange={(e) => this.handleCustomerPo(e, index)} disabled={(roles[12] && item.IssuedQuantity == item.icqty) || (roles[32] && item.IssuedQuantity == item.icqty) || (roles[33] && item.IssuedQuantity == item.icqty) ? true : false} /></td>
                                                                    : null}
                                                                {this.state.sendToValue == "Customer" ?
                                                                    <td><input type="text" value={item.BillingScheduleNo ? item.BillingScheduleNo : ""}
                                                                        onChange={(e) => this.billhandleChange(e, index)} disabled={(roles[12] && item.IssuedQuantity == item.icqty) || (roles[32] && item.IssuedQuantity == item.icqty) || (roles[33] && item.IssuedQuantity == item.icqty) ? true : false} />
                                                                    </td>
                                                                    : null}
                                                                {this.state.sendToValue == "Customer" ?
                                                                    <td><input type="text" value={item.BillScheduleDescription ? item.BillScheduleDescription : ""}
                                                                        onChange={(e) => this.billDeschanldeChange(e, index)} disabled={(roles[12] && item.IssuedQuantity == item.icqty) || (roles[32] && item.IssuedQuantity == item.icqty) || (roles[33] && item.IssuedQuantity == item.icqty) ? true : false} /></td>
                                                                    : null}
                                                                {this.state.sendToValue == "Vendor" ?
                                                                    <td style={{ minWidth: '300px !important' }}>
                                                                        {this.state.VendorLabel !== '' ?
                                                                            <Select placeholder="PO Number" maxMenuHeight={500} styles={customStyles} controlShouldRenderValue={true} options={this.state.vendorPOData} value={{ label: item.SendToPOSAPID }} onChange={(e) => this.handleToVendorPONo(e, index)}
                                                                                disabled={(roles[12] && item.IssuedQuantity == item.icqty) || (roles[32] && item.IssuedQuantity == item.icqty) || (roles[33] && item.IssuedQuantity == item.icqty) ? true : false} />
                                                                            : <span className='badge' style={{ display: 'flex', color: 'red', fontSize: 'inherit', marginTop: '4px' }}>Please Select a Vendor</span>}
                                                                    </td>
                                                                    : null}
                                                                {this.state.sendToValue == "Vendor" ?
                                                                    <td>
                                                                        {this.state.VendorLabel !== '' && item.SendToPOSAPID && item.SendToPOSAPID !== '' ?
                                                                            <Select placeholder="PO LineItemNo" maxMenuHeight={500} styles={customStyles} options={this.state.vendorPOLineItems} value={{ label: item.VendorPOLineItemNo }} onChange={(e) => this.handleToVendorPOLineItemNo(e, index)}
                                                                                disabled={(roles[12] && item.IssuedQuantity == item.icqty) || (roles[32] && item.IssuedQuantity == item.icqty) || (roles[33] && item.IssuedQuantity == item.icqty) ? true : false} />
                                                                            : <span className='badge' style={{ display: 'flex', color: 'red', fontSize: 'inherit', marginTop: '4px' }}>Please Select Vendor PO Number</span>}
                                                                    </td>
                                                                    : null}
                                                                {this.state.sendToValue == "Customer" ?
                                                                    <td><input type="text" value={item.CustomerBillingScheduleQuantity ? item.CustomerBillingScheduleQuantity : ""}
                                                                        onChange={(e) => this.handleCustomerBillingScheduleQuantity(e, index)} disabled={(roles[12] && item.IssuedQuantity == item.icqty) || (roles[32] && item.IssuedQuantity == item.icqty) || (roles[33] && item.IssuedQuantity == item.icqty) ? true : false} /></td>
                                                                    : null}
                                                                {this.state.sendToValue == "Customer" ?
                                                                    <td><input type="text" value={item.UOM ? item.UOM : ""}
                                                                        onChange={(e) => this.handleUOM(e, index)} disabled={(roles[12] && item.IssuedQuantity == item.icqty) || (roles[32] && item.IssuedQuantity == item.icqty) || (roles[33] && item.IssuedQuantity == item.icqty) ? true : false} /></td>
                                                                    : null}
                                                                <td><input type="text" value={item.Remarks ? item.Remarks : ""}
                                                                    onChange={(e) => this.handleRemarks(e, index)} disabled={(roles[12] && item.IssuedQuantity == item.icqty) || (roles[32] && item.IssuedQuantity == item.icqty) || (roles[33] && item.IssuedQuantity == item.icqty) ? true : false} /></td>
                                                            </tr>
                                                            <div style={{ maxWidth: "1387px", position: "absolute", width: "100%", zIndex: "99" }} className={index == this.state.multiCollapseIndex ? ` pt-2 mb-2 detailpanebackground container collapse multi-collapse${index}` : `container collapse`}>
                                                            </div>
                                                        </>
                                                    )
                                                })
                                                :
                                                this.state.tabledata.map((item, index) => {
                                                    console.log("jhgvfvds27",item,index)
                                                    return (
                                                        <>
                                                            <tr>
                                                                <td>{item.WBSCode ? item.WBSCode.includes('ET') ? (item.WBSCode).slice(0, 11) : (item.WBSCode).slice(0, 6) : "Other"}</td>
                                                                <td>{item.POLineItemDescription}</td>
                                                                <td><a href='DCListing'>{`IC-${item.POSAPId}-${item.POLineItemSAPCode}` + (item.POServiceLineItemSAPCode && "-" + item.POServiceLineItemSAPCode)}</a></td>
                                                                <td>{item.VendorName}</td>
                                                                <td>{item.POSAPId}</td>
                                                                <td>{item.POServiceLineItemSAPCode ? item.POServiceLineItemSAPCode : item.POLineItemSAPCode}</td>
                                                                <td>{(item.icqty).toFixed(2) + " " + item.OrderUnit}</td>
                                                                <td>{item.IssuedQuantity == null ? 0 : item.IssuedQuantity}{" " + item.OrderUnit}</td>
                                                                <td>{item.IssuedQuantity == null ? (item.icqty - 0).toFixed(2) : (item.icqty - item.IssuedQuantity).toFixed(2)}{" " + item.OrderUnit}</td>
                                                                <td>
                                                                    <input type="number" class="form-control"
                                                                        onChange={(e) => this.handlePDCInput(e, index, 1)}
                                                                        disabled={this.state.selectedPoId === 0 ? true : false}
                                                                        onBlur={() => this.handleSavePDC(item.RequestedQuantity, item.PurchaseOrderLineId, item.IssuedQuantity == null ? item.icqty - 0 : item.icqty - item.IssuedQuantity, item.BillingScheduleNo, item.BillScheduleDescription, 1)}
                                                                        value={item.RequestedQuantity ? item.RequestedQuantity : 0} />

                                                                </td>
                                                                <td>{item.IssuedQuantity == null ? ((item.icqty - 0) - item.RequestedQuantity).toFixed(2) : ((item.icqty - item.IssuedQuantity) - item.RequestedQuantity).toFixed(2)}{" " + item.OrderUnit}</td>
                                                                <td><input className='form-control' type="text" readOnly value={item.BillingScheduleNo ? item.BillingScheduleNo : ""} /></td>
                                                                <td><input type="text" className='form-control' readOnly
                                                                    value={item.BillScheduleDescription ? item.BillScheduleDescription : ""} /></td>
                                                                {this.state.sendToValue == "Customer" ?
                                                                    <td><input className='form-control' readOnly type="text" value={item.CustomerPo ? item.CustomerPo : ""}
                                                                        onChange={(e) => this.handleCustomerPo(e, index)} disabled={(roles[12] && item.IssuedQuantity == item.icqty) || (roles[32] && item.IssuedQuantity == item.icqty) || (roles[33] && item.IssuedQuantity == item.icqty) ? true : false} /></td>
                                                                    : null}
                                                                {this.state.sendToValue == "Customer" ?
                                                                    <td><input className='form-control' readOnly type="text" value={item.CustomerBillingScheduleQuantity ? item.CustomerBillingScheduleQuantity : ""}
                                                                        onChange={(e) => this.handleCustomerBillingScheduleQuantity(e, index)} disabled={(roles[12] && item.IssuedQuantity == item.icqty) || (roles[32] && item.IssuedQuantity == item.icqty) || (roles[33] && item.IssuedQuantity == item.icqty) ? true : false} /></td>
                                                                    : null}
                                                                {this.state.sendToValue == "Customer" ?
                                                                    <td><input className='form-control' readOnly type="text" value={item.UOM ? item.UOM : ""}
                                                                        onChange={(e) => this.handleUOM(e, index)} disabled={(roles[12] && item.IssuedQuantity == item.icqty) || (roles[32] && item.IssuedQuantity == item.icqty) || (roles[33] && item.IssuedQuantity == item.icqty) ? true : false} /></td>
                                                                    : null}
                                                                <td><input className='form-control' readOnly type="text" value={item.Remarks ? item.Remarks : ""}
                                                                    onChange={(e) => this.handleRemarks(e, index)} disabled={(roles[12] && item.IssuedQuantity == item.icqty) || (roles[32] && item.IssuedQuantity == item.icqty) || (roles[33] && item.IssuedQuantity == item.icqty) ? true : false} /></td>
                                                            </tr>
                                                            <div style={{ maxWidth: "1387px", position: "absolute", width: "100%", zIndex: "99" }} className={index == this.state.multiCollapseIndex ? ` pt-2 mb-2 detailpanebackground container collapse multi-collapse${index}` : `container collapse`}>
                                                            </div>
                                                        </>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                                <div style={{ width: '100%', marginTop: '20px' }}>
                                    <Pagination className='me-0, mb-0' style={{ justifyContent: 'center' }}>
                                        {handlepagecount}
                                    </Pagination>
                                </div>

                            </div>
                        </div>
                        <div>
                            <div className="sticky">
                                <div className="wrap">
                                    <table class="table table-bordered mt-4">
                                        <thead class="table sticky-inner" style={{ backgroundColor: "#0989CB", color: "white" }}>
                                            <tr>
                                                <th scope="col">Project Number</th>
                                                <th scope="col">PO Line item Description</th>
                                                <th scope="col" style={{ minWidth: '150px' }}>IC Number</th>
                                                <th scope="col">Vendor Name</th>
                                                <th scope="col">PO Number</th>
                                                <th scope="col" style={{ minWidth: '100px' }}>PO Line item no</th>
                                                <th scope="col" style={{ minWidth: '100px' }}>IC qty</th>
                                                <th scope="col" style={{ minWidth: '120px' }}>Qty Issued DC</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.iclistData.length > 0 ?
                                                this.state.iclistData.map((item, index) => {
                                                    return (
                                                        <>
                                                            <tr onClick={() => this.togglebutton(index)} data-toggle="collapse" data-target={`.multi-collapse${index}`}>
                                                                <td>{item.WBSCode ? item.WBSCode.includes('ET') ? (item.WBSCode).slice(0, 11) : (item.WBSCode).slice(0, 6) : "Other"}</td>
                                                                <td>{item.POLineItemDescription}</td>
                                                                <td>{`IC-${item.POSAPId}-${item.POLineItemSAPCode}` + (item.POServiceLineItemSAPCode && "-" + item.POServiceLineItemSAPCode)}</td>
                                                                <td>{item.VendorName}</td>
                                                                <td>{item.POSAPId}</td>
                                                                <td>{item.POServiceLineItemSAPCode ? item.POServiceLineItemSAPCode : item.POLineItemSAPCode}</td>
                                                                <td>{item.icqty + " " + item.OrderUnit}</td>
                                                                <td>{item.IssuedQuantity == null ? 0 : item.IssuedQuantity}{" " + item.OrderUnit}</td>
                                                            </tr>
                                                            <div style={{ maxWidth: "1387px", position: "absolute", width: "100%", zIndex: "99" }} className={index == this.state.multiCollapseIndex ? ` pt-2 mb-2 detailpanebackground container collapse multi-collapse${index}` : `container collapse`}>
                                                            </div>
                                                        </>
                                                    )
                                                })
                                                :
                                                null
                                            }
                                        </tbody>
                                    </table>
                                </div>
                                <div style={{ width: '100%', marginTop: '20px' }}>
                                    <Pagination className='me-0, mb-0' style={{ justifyContent: 'center' }}>
                                        {handlepagecount1}
                                    </Pagination>
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </>
        )
    }
}
const mapStateToProps = (state) => ({ dispatchOrderDetailsReducer: state.dispatchOrderDetailsReducer, file: state.file, filterList: state.masterReducer.filterList, poDetails: state.poDetails })
export default connect(mapStateToProps, { gettemplatemasterData, GetPOAndLineItemListForDispatch, GetPOAndLineItemListForDispatchICListing, GetPOAndLineItemListForDispatchForDCListing, GetPOAndLineItemListForDispatchBillingScheduleDetails, GetPOAndLineItemListForDispatchInspectionDetails, GetPOAndLineItemListForDispatchCount, GetPOAndLineItemListForDispatchonPONumber, postDispatchClearenceDetails, uploadFileGeneric, GetFilterList, generateDispatchClearence, getProjectAllocationByUserId, VendorDetails,getCustomerMaster })(DispatchClearanceTable)
